import React from 'react';
import PropTypes from 'prop-types';

import { Chart, Geom, Tooltip, Coord, Label, Legend, Guide } from "bizcharts";
const { Text } = Guide;

class Funnel extends React.PureComponent {
  render() {
    const { data, chart_props, action_key, percent_key, count_key, count_label } = this.props;
    const cols = { [percent_key]: { nice: false } };
    return (
      <Chart data={data} scale={cols} {...chart_props}>
        <Tooltip
          showTitle={false}
          itemTpl={`<li data-index={index} style=&quot;margin-bottom:4px;&quot;><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}<br/><span style=&quot;padding-left: 16px&quot;>${count_label}：{count}</span><br/><span style=&quot;padding-left: 16px&quot;>Percent：{percent}</span><br/></li>`}
        />
        <Coord type="rect" transpose scale={[1, -1]} />
        <Legend />
        <Guide>
          {
            data.map((obj, index) => {
              return (
                <Text key={index} top={true} position={{ [action_key]: obj[action_key], [percent_key]: "median" }} content={`${obj[percent_key]} %`} style={{ fill: "#fff", fontSize: "14", textAlign: "center" }} />
              );
            })
          }
        </Guide>
        <Geom
          type="intervalSymmetric"
          position={`${action_key}*${percent_key}`}
          shape="funnel"
          color={action_key}
          tooltip={[
            `${action_key}*${count_key}*${percent_key}`,
            (action, count, percent) => {
              return {
                name: action,
                percent: percent + "%",
                count: count
              };
            }
          ]}
        >
          <Label content={[`${action_key}*${count_key}`, (action, count) => action + " " + count]}
            offset={35}
            labeLine={{
              lineWidth: 1,
              stroke: "rgba(0, 0, 0, 0.15)"
            }}
          />
        </Geom>
      </Chart>
    );
  }
}

Funnel.propTypes = {
  data: PropTypes.array.isRequired,
  action_key: PropTypes.string,
  percent_key: PropTypes.string,
  count_key: PropTypes.string,
  count_label: PropTypes.string,
  chart_props: PropTypes.object,
}

Funnel.defaultProps = {
  action_key: 'action',
  percent_key: 'percent',
  count_key: 'count',
  count_label: "Count",
  chart_props: {
    forceFit: true,
    padding: [20, 120, 50, 50],
  }
}

export default Funnel;


// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/charts/funnel/index.js